// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"66f9e907","977":"c03a69c4"}[chunkId] + ".chunk.js";
};